import SearchComponent from "../../../../components/reusables/searchComponent";
import { AiFillMinusCircle, AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import ModalInfo from "../../../../components/lib/modalInfo";
import { GrCircleQuestion } from "react-icons/gr";
import { useEffect, useState } from "react";
import ClientService from "../../../../rest/clientService";
import CategorySelect from "../../../../components/reusables/categorySelect";

const RecipeRegisterFormStep2 = ({ formik }) => {
    const [preferences, setPreferences] = useState(null);

    useEffect(() => {
        ClientService.getClientAdminPreferences().then(setPreferences);
    }, []);

    const ingredientsList = Array.isArray(formik.values.ingredients)
        ? formik.values.ingredients
        : [];

    const handleIngredientSelect = (ingredient) => {
        const incomingName = ingredient.name.trim();

        const existingIndex = ingredientsList.findIndex(
            item => item.name.toLowerCase() === incomingName.toLowerCase()
        );

        if (existingIndex > -1) {
            const updated = [...ingredientsList];
            updated[existingIndex] = {
                ...updated[existingIndex],
                amount: (updated[existingIndex].amount || 0) + 1
            };
            formik.setFieldValue("ingredients", updated);
        } else {
            const newItem = {
                name: incomingName,
                amount: 1
            };
            formik.setFieldValue("ingredients", [...ingredientsList, newItem]);
        }
    };


    const handleIngredientAmount = (target, option) => {
        const updated = ingredientsList.map(item => {
            if (item.name === target.name) {
                const currentAmount = Number(item.amount) || 0;
                const newAmount =
                    option === "plus"
                        ? currentAmount + 1
                        : Math.max(1, currentAmount - 1);

                return { ...item, amount: newAmount };
            }
            return item;
        });

        formik.setFieldValue("ingredients", updated);
    };

    const handleIngredientRemove = (target) => {
        const filtered = ingredientsList.filter(
            item => item.name !== target.name
        );
        formik.setFieldValue("ingredients", filtered);
    };


    return (
        <div className="space-y-6 max-w-5xl mx-auto">
            <div className="items-center justify-between my-6">
                <label className="font-medium block mb-2">Lista de Ingredientes:</label>
                <SearchComponent
                    onIngredientSelect={handleIngredientSelect}
                    searchType={"products"}
                />

                <div className="mt-4 flex flex-col w-full text-sm border-2 border-slate-200 rounded max-h-60 overflow-y-auto bg-white">
                    {ingredientsList.length > 0 ? (
                        ingredientsList.map((i) => (
                            <div className='flex items-center justify-between border-b border-slate-200 p-2' key={String(i.product_id)}>
                                <p className="font-medium flex-1">{i.name}</p>
                                <div className="flex items-center gap-2 mr-4">
                                    <button
                                        type="button"
                                        onClick={() => handleIngredientAmount(i, 'minus')}
                                        className='p-1 border rounded-full hover:bg-gray-100 disabled:opacity-30'
                                        disabled={i.amount <= 1}
                                    >
                                        <AiOutlineMinus />
                                    </button>
                                    <span className="w-8 text-center font-bold">{i.amount}</span>
                                    <button
                                        type="button"
                                        onClick={() => handleIngredientAmount(i, 'plus')}
                                        className='p-1 border rounded-full hover:bg-gray-100'
                                    >
                                        <AiOutlinePlus />
                                    </button>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => handleIngredientRemove(i)}
                                    className="text-red-500 hover:scale-110 transition-transform"
                                >
                                    <AiFillMinusCircle size={24} />
                                </button>
                            </div>
                        ))
                    ) : (
                        <p className="p-4 text-gray-500 italic text-center">Nenhum ingrediente na lista.</p>
                    )}
                </div>
            </div>

            <label className="relative space-y-1">
                <p>Categoria</p>
                <CategorySelect
                    name="category"
                    value={formik.values.category}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    categories={preferences?.categories}
                />
                <p className={"text-red-500 text-xs font-medium min-h-[14px]"}>
                    {formik.touched.category && formik.errors.category}
                </p>
            </label>

            <label>
                <div className="flex items-center justify-between">
                    Descrição:
                    <ModalInfo icon={<GrCircleQuestion />} content="O campo de descrição do produto fica visível para todos os usuários, tanto na plataforma de gerenciamento, quanto na de compra (app)." />
                </div>
                <textarea className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.description && formik.errors.description ? 'border-red-500' : ''}`}
                    name="description"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.description} />

                {formik.touched.sku && formik.errors.description && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.description}</p>)}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    Observações:
                    <ModalInfo icon={<GrCircleQuestion />} content="O campo de observações fica visível apenas para usuários que utilizam a ferramenta de gerenciamento." />
                </div>
                <textarea className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.observations && formik.errors.observations ? 'border-red-500' : ''}`}
                    name="observations"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.observations} />

                {formik.touched.observations && formik.errors.observations && (<p className="text-red-500 text-xs font-medium absolute">{formik.errors.observations}</p>)}
            </label>
        </div>
    );
};

export default RecipeRegisterFormStep2;
